import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Table } from 'semantic-ui-react';
import styled from 'styled-components';
import { DiagnosisDto } from 'ts-types/api.types';

const StyledAnchor = styled.a`
`;

const StyledTableContainer = styled.div`
  overflow-x: auto;
`;

const StyledTableCell = styled(Table.Cell)`
  :focus {
    background: rgba(0, 0, 0, .08) !important;
  }

  .diagnosis-text {
    padding: 6px !important;
    font-size: 11px !important;
    cursor: pointer;
    max-width: 7rem;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

interface Props extends MessageSourceProps {
  foundDiagnoses: Array<DiagnosisDto>;
  searchBy: string;
  readOnly: boolean;
  onDiagnosisClicked: (diagnosis: string) => void;
  childRef: React.Ref<any>;
}

class DiagnosisTable extends Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  shouldComponentUpdate(
      nextProps: Readonly<Props>,
      nextState: Readonly<any>,
      nextContext: any): boolean {

    const props = this.props;

    if (props.foundDiagnoses === nextProps.foundDiagnoses
        && props.searchBy === nextProps.searchBy
        && props.readOnly === nextProps.readOnly) {
      return false;
    }

    return true;
  }

  onDiagnosisClicked = (code: string) => {
    const {readOnly} = this.props;
    if (!readOnly) {
      this.props.onDiagnosisClicked(code)
    }
  };

  handleKey = (e: any, diagnosis: string) => {

    e.preventDefault();

    const target = e.target;
    const keyCode = e.keyCode;
    const cellIndex = target.tabIndex;
    const rowIndex = target.parentElement.getAttribute('row-index');
    const numberOfRows = parseInt(target.offsetParent.rows.length) - 1;
    const maxNumberOfCells = target.offsetParent.rows[rowIndex].cells.length - 1;

    let tableCell;

    if (keyCode == 13) {
      this.onDiagnosisClicked(diagnosis);
    }

    if (keyCode == 37 && cellIndex > 0) {

      tableCell = target.offsetParent.rows[rowIndex].cells[cellIndex - 1];
      tableCell.focus();

    }

    if (keyCode == 39 && cellIndex >= 0 && cellIndex < maxNumberOfCells) {

      tableCell = target.offsetParent.rows[rowIndex].cells[cellIndex + 1];
      tableCell.focus();

    }

    if (keyCode == 38 && rowIndex > 0) {

      tableCell = target.offsetParent.rows[rowIndex - 1].cells[cellIndex];
      tableCell.focus();

    }

    if (keyCode == 40 && rowIndex < numberOfRows) {

      const index = parseInt(rowIndex) + 1;
      const rowCells = target.offsetParent.rows[index].cells.length;

      if (cellIndex < rowCells) {

        tableCell = target.offsetParent.rows[index].cells[cellIndex];
        tableCell.focus();

      }

    }

  };

  render(): React.ReactNode {
    const {
      foundDiagnoses,
      searchBy,
      getMessage
    } = this.props;

    let diagnosisTable = (
        <Table.Row>
          <Table.Cell>{getMessage("noResultsFound")}</Table.Cell>
        </Table.Row>
    );

    if (foundDiagnoses.length > 0) {
      const toMatrix = (arr: any, width: any) =>
          arr.reduce((rows: any, key: any, index: number) => (index % width == 0 ? rows.push([key])
              : rows[rows.length - 1].push(key)) && rows, []);

      const diagnosisMatrix = toMatrix(foundDiagnoses, 8);

      diagnosisTable = diagnosisMatrix[0].map((row: any, index: any) => {
        return (
            <Table.Row key={index} row-index={index}>
              {diagnosisMatrix.map((column: any, innerIndex: number) => {
                if (column[index] != undefined) {
                  if (searchBy == "description") {

                    const description = column[index].description;

                    return (
                        <StyledTableCell
                            className="diagnosis-table"
                            key={innerIndex}
                            selectable
                            width={3}
                            tabIndex={innerIndex}
                            onKeyDown={(e: any) => this.handleKey(e, column[index].code)}
                        >
                          <StyledAnchor
                              className="diagnosis-text"
                              title={description}
                              onDoubleClick={() => this.onDiagnosisClicked(column[index].code)}
                          >
                            {description}
                          </StyledAnchor>
                        </StyledTableCell>
                    );
                  }
                  return (
                      <StyledTableCell key={innerIndex} selectable width={1} tabIndex={innerIndex}
                                       onKeyDown={(e: any) => this.handleKey(e, column[index].code)}>
                        <StyledAnchor
                            className="diagnosis-text"
                            onDoubleClick={() => this.onDiagnosisClicked(column[index].code)}
                        >
                          {column[index].code}
                        </StyledAnchor>
                      </StyledTableCell>
                  );
                }
              })}
            </Table.Row>
        );
      });
    }

    return (
        <StyledTableContainer ref={this.props.childRef}>
          <Table celled singleLine compact="very">
            <Table.Body>
              {diagnosisTable}
            </Table.Body>
          </Table>
        </StyledTableContainer>
    );
  };

}

export default withMessages(DiagnosisTable);
